import React, {useState, useEffect, useRef} from 'react';
import {
  View,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
  Animated,
  Easing,
} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton';
import Feather from '@expo/vector-icons/Feather';
import Box from '@/Atoms/Box';
import useGetTournamentDetails from '@/Hooks/TournamentsApi/useGetTournamentDetails';
import NotationComponent from '@/Screens/PlayChess/components/NotationComponent';
import useGetUserGamesApi from '@/Hooks/GetUserGamesApi/useGetUserGamesApi';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';

// Import individual components for tabs
import Standings from './standings'; // Replace with your actual component
import Games from './games'; // Replace with your actual component
// import Chat from './chat'; // Replace with your actual component
import TournamentDetails from './TournamentDetails'; // Replace with your actual component
import BottomControlsComponent from '@/Screens/PlayChess/components/BottomControlsComponent';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {hasTracingEnabled} from '@sentry/core';
import {CustomInfoBox} from '@/Atoms/InfoIcon';
import {useNavigation, useRoute} from '@react-navigation/native';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import {debounce, formattedTimeInDays} from '@/Utils/CommonUtils';
import useLoggedInUserStore from '@/Store/loggedInUserstore';
import useVerifyTournamentPassword from '@/Hooks/TournamentsApi/useVerifyTournamentPassword';
import SlideModal from '@/Atoms/SlideModal';
import CCTextInput from '@/Atoms/CCTextInput';
import ExclamationIcon from '@/Assets/Images/Svgs/ExclamationIcon';
import Spacer from '@/Atoms/Spacer';
import {FontSizes, hs, vs} from '@/Utils/Dimensions';
import useGamePlayState from '@/Store/GamePlayStore';
import TournamentEndedModal from './TournamentEndedModal';
import useGetTournamentStandings from '@/Hooks/TournamentsApi/useGetTournamentStandings';
import useGetOpeningIntelligenceReportApi from '@/Hooks/AssessmentApi/useGetOpeningIntelligenceReportApi';
import {LinearGradient} from 'expo-linear-gradient';
import {PopUp} from '@/Screens/Visualisation/components/LevelModal';
import search from '@/Assets/Images/png/search.png';
import DotLoader from './DotLoader';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import PaidTournamentRegistrationModal from './PaidTournamentRegistrationModal';

const TournamentPlay = props => {
  // Default tab
  const {
    moves,
    opponentTime,
    myTime,
    myTurn,
    username,
    white,
    displayName,
    opponent,
    whitePieces,
    blackPieces,
    setPosition,
    firstMoveTimer,
    showFirstMoveTimer,
    setMoveClicked,
    setMoveSelected,
    startfen,
    setPreviousFen,
    myRating,
    opponentRating,
    playing,
    setHint,
    setHint2,
    isBlackTurnFirst,
    position,
    setShowIncorrectHintModal,
    tournamentId,
    current_round,
    handleBack,
    joinTournament,
    playersJoined,
    userId,
    active_tab,
    roundStartTime,
    setWhitePlayer,
    game_uuid,
    roundEnd,
    showDrawRequest,
    drawRequestSent,
    drawRequest,
    handleDrawResponse,
    resign,
    abort,
    showAbort,
    showDrawReject,
    setShowDrawReject,
    setGameId,
    tournamentMoves,
    startfenTournament,
    withDrawPlayer,
    illegalTouchPieceCount,
    setMyTimeTournament,
    setOpponentTimeTournament,
    started,
    watchTournamentGame,
    watchGame,
    setStarted,
    tournamentEnded,
    gamesEnded,
    isConnected,
    joinMessage,
    joinTnrSuccess,
    setJoinTnrSuccess,
    displayNameTournament,
    setWithdraw,
    ongoingGames,
    isPairingGenerated,
    getTournamentStatus,
    tournamentState,
    tournamentStatusMessage,
  } = props;
  const [round, setRound] = useState(current_round);
  const [activeTab, setActiveTab] = useState(active_tab);
  const [isTournamentActive, setIsTournamentActive] = useState(true);
  const navigation = useNavigation();
  const route = useRoute();
  const {isMobileOrTab} = useMediaQuery();
  const [showPaidRegisterModal, setShowPaidRegisterModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [rank, setRank] = useState(0);
  const [score, setScore] = useState(0);
  const [rating, setRating] = useState(0);
  const {mutate: fetchTournamentStandings, data: tournamentStandings} =
    useGetTournamentStandings();
  const [isOngoing, setIsOngoing] = useState(false);
  const [joinModalVisible, setJoinModalVisible] = useState(false);
  const [searchTab, setSearchTab] = useState(false);
  const [showSearch, setShowSearch] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewPlayer, setViewPlayer] = useState(true);
  const [viewPlayerGame, setViewPlayerGame] = useState(false);
  const [playerName, setPlayerName] = useState('');
  const [playerId, setPlayerId] = useState('');
  const [playerUserId, setPlayerUserId] = useState<string | null>(null);
  const [refreshApi, setRefreshApi] = useState(false);

  // Fetch the tournament details when the component mounts
  // useEffect(() => {
  //   if (tournamentId && tournamentEnded) {
  //     fetchTournamentStandings({
  //       round: round,
  //       tournamentId: String(tournamentId),
  //       limit: 10,
  //       offset: 0,
  //       userId: userId,
  //     });
  //   }
  // }, [tournamentEnded, userId]);

  // useEffect(() => {
  //   // Uncomment the following block once the API is ready
  //   if (tournamentStandings) {
  //     // const rank = getRank(tournamentStandings?.data, username);
  //     const user = tournamentStandings?.data.find(
  //       d => d.cc_userid === Number(userId),
  //     );
  //     setTotalPlayers(tournamentStandings?.count);
  //     // if (user && tournamentEnded) {
  //     //   setRank(user?.rank);
  //     //   setScore(user?.point || 0);
  //     //   setRating(user?.player_rating || 0);
  //     //   setShowModal(true);
  //     // }
  //   }
  // }, [tournamentStandings, tournamentEnded]);
  const [totalPlayers, setTotalPlayers] = useState(0);
  const handleVerifyPassword = (response: any) => {
    if (response?.status) {
      setShowPasswordModal(false);
      setPasswordError('');
    }
  };
  const {mutate: verifyPassword} = useVerifyTournamentPassword(
    handleVerifyPassword,
    error => {
      setPasswordError(error?.response?.data?.message);
    },
  );

  // const [gameId, setGameId] = useState('');
  // const [myGame, setMyGame] = useState(true);

  // const {mutate: fetchGames, data} = useGetUserGamesApi(
  // );
  // useEffect(() => {
  //   if (gameId) {
  //     fetchGames({page: 1, game_id: gameId});
  //   } else if (game_uuid) {
  //     fetchGames({page: 1, game_id: game_uuid});
  //   }
  // }, [gameId, game_uuid]);

  // useEffect(() => {
  //   if (data) {
  //     console.log("game fetched by game id, data:",data);
  //     setWhitePlayer((data?.data?.data.username == displayName || data?.data?.data.opponent_username == displayName) ? (data?.data?.data?.userid == userId && data?.data?.data?.color == 'White' ? userId : data?.data?.data?.opponent_username) : data?.data?.data?.color == 'White' ? userId : '' );
  //     setMyGame(data?.data?.data.username == displayName || data?.data?.data.opponent_username == displayName);
  //     setPosition(data?.data?.data?.start_fen);
  //   }
  // }, [data]);

  const [details, setDetails] = useState({
    timeControl: '25min',
    tournamentDuration: '4hrs',
    ratedGames: 'No',
    completedGames: 10,
    rounds: 24,
    players: '30',
    players_joined: [],
    currentRound: 0,
    start_date: '',
    cash_prize: 0,
    entry_fee: 0,
    players_count: 0,
    brochure: '',
    t_id: 0,
    parent_id: 0,
    tournament_notes: [] as string[],

  });

  const {
    mutate: fetchTournamentDetails,
    data: tournamentData,
    isLoading,
    isError,
    error,
  } = useGetTournamentDetails();

  useEffect(() => {
    if (refreshApi && activeTab === 'details') {
      const payload: any = {
        tournamentId,
        userId,
      };

      fetchTournamentDetails(payload, {
        onSuccess: () => {
          setRefreshApi(false);
        },
      });
    }
  }, [refreshApi]);

  // Fetch the tournament details when the component mounts
  useEffect(() => {
    if ((tournamentId && userId) || isPairingGenerated) {
      console.log('inside fetch details', isConnected);
      console.log('userId:', userId, tournamentId);
      fetchTournamentDetails({tournamentId, userId});
    }
    if (joinTnrSuccess === 1) {
      setJoinModalVisible(true);
      // setShowFullPageLoader(false);
    } else {
      setJoinModalVisible(false);
      // setShowJoinSuccessModal(false);
    }
  }, [playersJoined, isConnected, joinTnrSuccess, userId, isPairingGenerated]);

  useEffect(() => {
    console.log('inside active_tab change useEffect active_tab:', active_tab);
    setActiveTab(active_tab);
  }, [active_tab]);

  useEffect(() => {
    setRound(current_round);
  }, [current_round]);

  useEffect(() => {
    setSearchTab(false);
    setSearchTerm('');
    // setPlayerUserId(null);
  }, [activeTab]);
  useEffect(() => {
    getTournamentStatus(tournamentId);
  }, []);

  const [statusMessage, setStatusMessage] = useState<string>('');
  const [timeLeft, setTimeLeft] = useState<string>('');
  const [start_date, setStartDate] = useState<string>('');
  const [tournamentStarted, setTournamentStarted] = useState(0);
  const userData = useLoggedInUserStore(state => state.userData);
  const [showWarning, setShowWarning] = useState(false);
  const timeControlRef = useRef(600);
  const gameplayStore = useGamePlayState();
  const [showModal, setShowModal] = useState(false);
  const [roundsPlayed, setRoundsPlayed] = useState(0);
  const [showWithdrawPopup, setShowWithdrawPopup] = useState(false);
  const [isJoining, setIsJoining] = useState(false);
  const handleClose = () => {
    setShowModal(false);
  };
  const [showOngoingTab, setShowOngoingTab] = useState(true);
  const {data: openingReportData, isLoading: openingReportLoading, isError: openingReportError} =
    useGetOpeningIntelligenceReportApi({
      tournamentId,
      enabled: Boolean(
        tournamentId &&
          tournamentData?.data?.parent_id &&
          !tournamentData?.data?.is_qualified,
      ),
    });
  const hasOpeningReportGenerated = Boolean(
    !openingReportLoading &&
      !openingReportError &&
      (openingReportData as any)?.data &&
      ((openingReportData as any)?.data?.assessment_id ||
        (openingReportData as any)?.data?.frontend_view),
  );
  const reportPendingMessage =
    'Your opening report is being prepared, check back soon!';
  const qualificationStatusMessage =
    tournamentData?.data?.status_message ||
    (tournamentEnded && !hasOpeningReportGenerated ? reportPendingMessage : '');

  const getRoundStartFen = (roundPositions: any[] = [], selectedRound = 1) => {
    if (!Array.isArray(roundPositions) || roundPositions.length === 0) {
      return null;
    }

    const safeRound = Number(selectedRound) > 0 ? Number(selectedRound) : 1;
    const targetRoundData =
      roundPositions.find(item => Number(item?.round_number) === safeRound) ||
      roundPositions.find(item => Number(item?.round_number) === 1);

    return targetRoundData?.positions?.[0] || null;
  };

  const buildTournamentNotes = (
    notes: any,
    roundPositions: any[] = [],
    selectedRound = 1,
  ) => {
    const fen = getRoundStartFen(roundPositions, selectedRound);
    const fenPrefix = 'Starting Position (FEN):';
    const safeNotes = Array.isArray(notes) ? notes : [];

    if (!fen) return safeNotes;

    const notesWithUpdatedFen = safeNotes.map(note => {
      if (typeof note === 'string' && note.trim().startsWith(fenPrefix)) {
        return `${fenPrefix} ${fen}`;
      }
      return note;
    });

    const hasFenNote = notesWithUpdatedFen.some(
      note => typeof note === 'string' && note.trim().startsWith(fenPrefix),
    );

    if (!hasFenNote) {
      return [`${fenPrefix} ${fen}`, ...notesWithUpdatedFen];
    }

    return notesWithUpdatedFen;
  };

  useEffect(() => {
    console.log('Initial start_date:', start_date, 'state', tournamentState, 'message', tournamentStatusMessage);

    const startTime = new Date(start_date).getTime();
    if (isNaN(startTime)) {
      console.error('Invalid start_date format:', start_date);
      setStatusMessage('');
      return;
    }

    let intervalId;

    const updateStatus = () => {
      const now = new Date().getTime();
      let difference = startTime - now - 10000;

      // Handle pre-tournament countdown (dynamic)
      if (difference > 0) {
        const totalSeconds = Math.floor(difference / 1000);
        const days = Math.floor(totalSeconds / (24 * 60 * 60));
        const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        setStatusMessage('Tournament starts in');
        // const formattedTime =
        //   hours > 0
        //     ? `${hours}:${String(minutes).padStart(2, '0')}:${String(
        //         seconds,
        //       ).padStart(2, '0')}`
        //     : `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        //         2,
        //         '0',
        //       )}`;
        setTimeLeft(formattedTimeInDays(days, hours, minutes, seconds));
        return;
      } else {
        setTournamentStarted(1);
      }

      // Handle round countdown (dynamic)
      if (roundStartTime) {
        let difference2 = roundStartTime - now;
        if (difference2 > 0) {
          const hours = Math.floor(difference2 / 1000 / 60 / 60);
          const minutes = Math.floor((difference2 / 1000 / 60) % 60);
          const seconds = Math.floor((difference2 / 1000) % 60);

          setStatusMessage(`Round ${round} starts in`);
          const formattedTime =
            hours > 0
              ? `${hours}:${String(minutes).padStart(2, '0')}:${String(
                  seconds,
                ).padStart(2, '0')}`
              : `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
                  2,
                  '0',
                )}`;
          setTimeLeft(formattedTime);
          return;
        }
      }

      // All static states - clear interval since no countdown needed
      clearInterval(intervalId);
      setTimeLeft('');

      // Handle tournament start transition
      // if (difference < 0 && difference > -9000) {
      //   // Within 30 seconds of tournament start
      //   setTouramentStarted(1);
      //   setStatusMessage('Generating Pairing');
      // }
      // Handle static states

      if (isTournamentActive && tournamentState) {
        // if (tournamentData?.data?.is_joined) {
        //   if (isPairingGenerated) {
        //     setStatusMessage(`Preparing for Round ${round + 1}`);
        //   } else if (roundEnd) {
        //     setStatusMessage(`Round ${round} completed`);
        //     setTimeout(() => {
        //       setStatusMessage(`Generating Pairings for Round ${round + 1}`);
        //     }, 1000);
        //   } else if (round) {
        //     if (Number(ongoingGames) > 0) {
        //       setStatusMessage(
        //         `Round ${round} in progress, ${ongoingGames} ongoing games`,
        //       );
        //     } else {
        //       setStatusMessage(`Round ${round} in progress`);
        //     }
        //   } else {
        //     setStatusMessage('');
        //   }
        // } else {
        //   setStatusMessage(`Round ${round || 1} in progress`);
        // }
        setStatusMessage(tournamentStatusMessage);
      } else if (tournamentEnded || !isTournamentActive) {
        if (tournamentState == 'custom') {
          setStatusMessage(tournamentStatusMessage)
        } else {
          setStatusMessage('All Rounds Completed Successfully');
        }
        setIsOngoing(false);
        setShowOngoingTab(false);
        // setShowModal(true);
      }
    };

    // Handle static state updates immediately (no interval needed)
    const handleStaticUpdates = () => {
      const now = new Date().getTime();
      let difference = startTime - now - 10000;

      // Only set up interval if we need dynamic countdown
      const needsCountdown =
        difference > 0 || (roundStartTime && roundStartTime > now);

      if (needsCountdown) {
        updateStatus();
        intervalId = setInterval(updateStatus, 1000);
      } else {
        updateStatus(); // Handle static state once
      }
    };

    handleStaticUpdates();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [
    start_date,
    roundStartTime,
    roundEnd,
    current_round,
    isConnected,
    tournamentEnded,
    isTournamentActive,
    ongoingGames,
    isPairingGenerated,
    tournamentData?.data?.current_round,
    tournamentData?.data?.is_joined,
    tournamentState,
    tournamentStatusMessage,
  ]);

  useEffect(() => {
    // Uncomment the following block once the API is ready
    if (tournamentData) {
      if (
        tournamentData?.data?.is_private &&
        !tournamentData?.data?.is_joined
      ) {
        console.log('Tournament is private');
        setShowPasswordModal(true);
      }
      const selectedRound =
        Number(tournamentData?.data?.currentRound) > 0
          ? Number(tournamentData?.data?.currentRound)
          : 1;
      const notesWithDynamicFen = buildTournamentNotes(
        tournamentData.data.tournament_notes,
        tournamentData?.data?.roundPositions,
        selectedRound,
      );

      setDetails({
        timeControl: tournamentData.data.time_control || 'N/A',
        tournamentDuration: tournamentData.data.duration || 'N/A',
        ratedGames: tournamentData.data.rated ? 'Yes' : 'No',
        completedGames: tournamentData.data.completedGames || 0,
        rounds: tournamentData.data.rounds || 0,
        currentRound: tournamentData.data.currentRound || 0,
        players: `${tournamentData.data.players_count || 0}`,
        players_joined: tournamentData.data.players_joined,
        start_date: tournamentData.data.start_date,
        cash_prize: tournamentData.data.cash_prize,
        entry_fee: tournamentData.data.entry_fee,
        players_count: tournamentData.data.players_count,
        brochure: tournamentData.data.brochure,
        t_id: tournamentData.data.id,
        parent_id: tournamentData.data.parent_id || 0,
        tournament_notes: notesWithDynamicFen,
      });
      timeControlRef.current =
        tournamentData.data.time_control.split('+')[0] * 60;
      setMyTimeTournament(tournamentData.data.time_control.split('+')[0] * 60);
      setOpponentTimeTournament(
        tournamentData.data.time_control.split('+')[0] * 60,
      );
      setTotalPlayers(tournamentData.data.players_count || 0);
      setRoundsPlayed(tournamentData.data.rounds || 0);
      setRound(tournamentData?.data?.current_round || 1);
      setStartDate(tournamentData?.data?.start_date);
      setIsTournamentActive(tournamentData?.data?.is_active);
      if (!tournamentData?.data?.is_active) {
        // setStatusMessage('All Rounds Completed Successfully');
        setIsOngoing(false);
        setShowOngoingTab(false);
      }
      navigation.setParams({
        tournamentId,
        tournamentName: tournamentData?.data?.name.replace(/ /g, '-'),
      });
    }
  }, [tournamentData]);

  useEffect(() => {
    if (playing || started || watchGame) return;

    const targetFen = getRoundStartFen(tournamentData?.data?.roundPositions, round);

    if (targetFen && position !== targetFen) {
      setPosition(targetFen);
    }
  }, [tournamentData, round, playing, started, watchGame, position, setPosition]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'standings':
        return (
          <ScrollView showsVerticalScrollIndicator={false}>
            <Standings
              round={round}
              tournamentId={tournamentId}
              isConnected={isConnected}
              standings={tournamentStandings}
              username={username}
              searchterm={searchTerm}
              details={details}
              displayNameTournament={displayNameTournament}
              setGameId={setGameId}
              setActiveTab={setActiveTab}
              playing={playing}
              watchTournamentGame={watchTournamentGame}
              setShowSearch={setShowSearch}
              setSearchTab={setSearchTab}
              viewPlayer={viewPlayer}
              setViewPlayer={setViewPlayer}
              playerName={playerName}
              setPlayerName={setPlayerName}
              playerId={playerId}
              setPlayerId={setPlayerId}
              viewPlayerGame={viewPlayerGame}
              setViewPlayerGame={setViewPlayerGame}
              userId={userId}
              setPlayerUserId={setPlayerUserId}
              refreshApi={refreshApi}
              setRefreshApi={setRefreshApi}
              activeTab={activeTab}
            />
          </ScrollView>
        );
      case 'games':
        return (
          <ScrollView showsVerticalScrollIndicator={false}>
            <Games
              round={round}
              tournamentId={tournamentId}
              setGameId={setGameId}
              setActiveTab={setActiveTab}
              playing={playing}
              isMobileOrTab={isMobileOrTab}
              watchTournamentGame={watchTournamentGame}
              showOngoingTab={showOngoingTab}
              gamesEnded={gamesEnded}
              isConnected={isConnected}
              isOngoing={isOngoing}
              setIsOngoing={setIsOngoing}
              searchterm={searchTerm}
              username={username}
              userId={playerUserId}
              setPlayerUserId={setPlayerUserId}
              refreshApi={refreshApi}
              setRefreshApi={setRefreshApi}
              activeTab={activeTab}
            />
          </ScrollView>
        );
      case 'notation':
        return playing || started ? (
          <Box flexDirection="column" flex={10}>
            <Box flex={8}>
              <NotationComponent
                moves={moves}
                opponentTime={opponentTime}
                myTime={myTime}
                myTurn={myTurn}
                username={username}
                white={white}
                displayName={displayName}
                opponent={opponent}
                whitePieces={whitePieces}
                blackPieces={blackPieces}
                setPosition={setPosition}
                firstMoveTimer={firstMoveTimer}
                showFirstMoveTimer={showFirstMoveTimer}
                setMoveClicked={setMoveClicked}
                setMoveSelected={setMoveSelected}
                startfen={startfen}
                setPreviousFen={setPreviousFen}
                myRating={myRating}
                opponentRating={opponentRating}
                playing={playing}
                setHint={setHint}
                setHint2={setHint2}
                isBlackTurnFirst={isBlackTurnFirst}
                position={position}
                setShowIncorrectHintModal={setShowIncorrectHintModal}
                showPlayerComponent={false}
                illegalTouchPieceCount={illegalTouchPieceCount}
              />
            </Box>
            {playing && (
              <Box flex={2} style={{marginTop: 10}}>
                <BottomControlsComponent
                  showDrawRequest={showDrawRequest}
                  drawRequestSent={drawRequestSent}
                  drawRequest={drawRequest}
                  handleDrawResponse={handleDrawResponse}
                  resign={resign}
                  abort={abort}
                  showAbort={false}
                  playing={playing}
                  showDrawReject={showDrawReject}
                  setShowDrawReject={setShowDrawReject}
                />
              </Box>
            )}
          </Box>
        ) : (
          <NotationComponent
            moves={tournamentMoves}
            opponentTime={''}
            myTime={''}
            myTurn={myTurn}
            username={''}
            white={''}
            displayName={displayName}
            opponent={opponent}
            startfen={startfenTournament || startfen}
            myRating={myRating}
            opponentRating={opponentRating}
            whitePieces={[]}
            blackPieces={[]}
            setPosition={setPosition}
            firstMoveTimer={firstMoveTimer}
            showFirstMoveTimer={false}
            setMoveClicked={setMoveClicked}
            setMoveSelected={setMoveSelected}
            setPreviousFen={setPreviousFen}
            playing={playing}
            setHint={setHint}
            setHint2={setHint2}
            setShowIncorrectHintModal={setShowIncorrectHintModal}
            showPlayerComponent={false}
            illegalTouchPieceCount={illegalTouchPieceCount}
          />
        );
      case 'details':
        return (
          <ScrollView showsVerticalScrollIndicator={false}>
            <TournamentDetails
              tournamentId={tournamentId}
              details={details}
              hasOirReport={hasOpeningReportGenerated}
            />
          </ScrollView>
        );
      default:
        return (
          <ScrollView showsVerticalScrollIndicator={false}>
            <TournamentDetails
              tournamentId={tournamentId}
              details={details}
              hasOirReport={hasOpeningReportGenerated}
            />
          </ScrollView>
        );
    }
  };

  const spinAnim = useRef(new Animated.Value(0)).current;

  const rotateIcon = () => {
    spinAnim.setValue(0);

    Animated.timing(spinAnim, {
      toValue: 1,
      duration: 300,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start();
    setRefreshApi(true);
  };

  const spin = spinAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });

  const handleJoin = () => {
    setIsJoining(true);
    debouncedJoin();
  };

  const debouncedJoin = debounce(() => {
    joinTournament(tournamentId.toString());
    setIsJoining(false);
  }, 500);

  const handleWithDraw = debounce(() => {
    setWithdraw(true);
    withDrawPlayer(username, tournamentId, round);
    fetchTournamentDetails({tournamentId, userId});
  }, 500);

  const routeOrderId = (route.params as {order_id?: string} | undefined)
    ?.order_id;
  const isPaidTournament =
    tournamentData?.data?.is_free === false ||
    Number(tournamentData?.data?.entry_fee || 0) > 0;
  const isRegisteredForPaid = tournamentData?.data?.is_registered === true;
  const isPaidUnregistered =
    !tournamentData?.data?.is_joined &&
    isPaidTournament &&
    !isRegisteredForPaid;

  const showJoin =
    tournamentData &&
    tournamentData?.data?.enable_registration &&
    !showPasswordModal &&
    !tournamentData?.data?.is_joined &&
    !isPaidUnregistered &&
    (!tournamentData?.data?.parent_id ||
      (tournamentData?.data?.parent_id && tournamentData?.data?.is_qualified));
  const showWithdraw =
  tournamentData?.data?.parent_id !==3400 && //removing the withdraw for Mastery series but maybe we should pass dontShowWithDraw from backend
    tournamentData?.data?.is_joined &&
    statusMessage !== 'All Rounds Completed Successfully' &&
    !playing &&
    !roundEnd &&
    !roundStartTime &&
    (!tournamentStarted ||
      (tournamentStarted && tournamentData?.data?.pairingEngine === 'javafo'));

  return (
    <SafeAreaView style={styles.container}>
      {/* Tournament Header */}
      <SlideModal
        visible={joinModalVisible}
        // showCloseIcon={true}
        modalHeaderTitle={''}
        type="center"
        customHeaderStyle={{
          display: 'none',
        }}>
        <Box
          flexDirection="column"
          style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Box
            style={{
              position: 'absolute',
              right: 5,
              top: 5,
            }}>
            {/* <TouchableOpacity
              onPress={() => {
                setJoinTnrSuccess(0);
                setJoinModalVisible(false);
                console.log(joinTnrSuccess, 'joinTnrSuccess in modal 2');
              }}>
              <Box
                justifyContent="center"
                alignItems="center"
                style={{
                  width: 40,
                  height: 40,
                  backgroundColor: CCColors.Primary.lightBrown,
                  borderRadius: 20,
                  marginBottom: 15,
                  marginRight: 8,
                }}>
                <Ionicons
                  name="close"
                  size={24}
                  color={CCColors.Primary.Brown}
                />
              </Box>
            </TouchableOpacity> */}
            <Spacer spacing={vs(10)} />
          </Box>
          <View
            style={{
              paddingTop: vs(40),
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <Box
              style={{
                borderRadius: 50,
                width: 70,
                height: 70,
                backgroundColor: '#EB5757',

                marginVertical: vs(15),
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <MaterialCommunityIcons
                name="alert-box-outline"
                size={30}
                color={CCColors.White}
              />
            </Box>
            <CCText textAlign="justify" fontSize={18} fontWeight={500}>
              {tournamentData?.data?.is_joined
                ? 'Already Joined'
                : "You're not eligible for this tournament"}
            </CCText>
            <CCText
              textAlign="center"
              fontSize={16}
              style={{
                marginHorizontal: hs(20),
                marginTop: vs(8),
                marginBottom: vs(10),
              }}>
              {joinMessage}
            </CCText>
          </View>
          <CCButton
            style={{marginVertical: vs(15), width: '100%'}}
            onPress={() => {
              setJoinModalVisible(false);
              handleBack();
              setJoinTnrSuccess(0);
            }}
            contentContainerStyle={{
              paddingHorizontal: 90,
            }}>
            <CCText fontSize={16} fontWeight={600}>
              All Tournaments
            </CCText>
          </CCButton>
        </Box>
      </SlideModal>
      {showPasswordModal && (
        <SlideModal
          showCloseIcon={false}
          visible={showPasswordModal}
          modalHeaderTitle={'Enter Password to Join'}>
          <View style={{padding: 30}}>
            <CCTextInput
              placeholder="Enter Password"
              onChangeText={text => setPassword(text)}
            />
            {passwordError && (
              <Box
                style={{
                  marginLeft: 2,
                  marginTop: 2,
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}>
                <ExclamationIcon color={'#D64E59'} width={13} />
                <CCText
                  color={CCColors?.Error}
                  fontSize={11}
                  style={{marginLeft: 6}}>
                  {passwordError}
                </CCText>
              </Box>
            )}
            <Spacer spacing={vs(20)} />
            <CCButton
              type="fill"
              onPress={() =>
                verifyPassword({
                  tournamentId: tournamentId,
                  password,
                })
              }>
              Verify Password
            </CCButton>
            <Spacer spacing={vs(10)} />
            <CCButton
              style={{
                backgroundColor: updateColorWithOpacity(
                  CCColors?.Buttons?.Background,
                  0.5,
                ),
              }}
              type="fill"
              onPress={handleBack}>
              <Feather name="arrow-left" size={20} /> Back
            </CCButton>
          </View>
        </SlideModal>
      )}
      {
        <View style={styles.header}>
          {!(
            tournamentStarted &&
            tournamentData?.data?.is_joined &&
            tournamentData?.data?.is_active
          ) && (
            <TouchableOpacity
              style={styles.backButton}
              onPress={() => {
                if (!playing && watchGame) {
                  setActiveTab('details');
                  setGameId('stop_watching');
                } else if (viewPlayerGame) {
                  setActiveTab('standings');
                } else {
                  handleBack();
                }
              }}>
              <Feather name="arrow-left" size={24} color="#5B5B5B" />
            </TouchableOpacity>
          )}

          <View style={styles.titleContainer}>
            <CCText style={styles.title}>{tournamentData?.data?.name}</CCText>
            <Box flexDirection="row" marginTop={4}>
              <Box flexDirection="row" alignItems="flex-start">
                <CCText style={styles.subtitle}>Swiss &nbsp;• &nbsp;</CCText>
              </Box>
              <Box flexDirection="row" alignItems="flex-start">
                <Icon
                  name={'gamepad-circle-outline'}
                  size={18}
                  color={CCColors?.TextColor?.LightGrey}
                />
                &nbsp;
                <CCText style={styles.subtitle}>
                  {tournamentData?.data?.rounds} &nbsp; • &nbsp;
                </CCText>
              </Box>
              <Box flexDirection="row" alignItems="flex-start">
                <Icon
                  name={'timer-outline'}
                  size={18}
                  color={CCColors?.TextColor?.LightGrey}
                />
                <CCText style={styles.subtitle}>
                  &nbsp;
                  {tournamentData?.data?.time_control} &nbsp; • &nbsp;
                </CCText>
              </Box>
              <Box flexDirection="row" alignItems="flex-start">
                <Icon
                  name={'account-multiple-outline'}
                  size={18}
                  color={CCColors?.TextColor?.LightGrey}
                />
                &nbsp;
                <CCText style={styles.subtitle}>
                  {tournamentData?.data?.players_count}
                </CCText>
              </Box>
            </Box>
          </View>
          <View style={styles.actions}>
            {/* <Box style={styles.iconButton}>
            <Feather name="edit-2" size={16} color="#5B5B5B" />
          </Box> */}
            {watchGame ? (
              <Box
                style={{
                  backgroundColor: CCColors.Primary.Default,
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 10,
                  borderRadius: 20,
                }}
                onPress={() => {
                  setActiveTab('games');
                  if (!playing) {
                    if (watchGame) {
                      setGameId('stop_watching');
                    } else {
                      setGameId('');
                      setStarted(false);
                      setPosition(
                        'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
                      );
                    }
                  }
                  // setMyTimeTournament(timeControlRef.current);
                  // setOpponentTimeTournament(timeControlRef.current);
                }}>
                <CCText fontWeight={500} fontSize={FontSizes[14]}>
                  Stop Watching
                </CCText>
              </Box>
            ) : (
              showWithdraw && (
                <CustomInfoBox
                  text="Withdraw from the tournament"
                  customView={
                    <Box
                      style={styles.iconButton}
                      onPress={() => setShowWithdrawPopup(true)}>
                      <CCText
                        fontSize={FontSizes[12]}
                        fontWeight={500}
                        color={CCColors?.WrongMoves?.Background}>
                        Withdraw
                      </CCText>
                    </Box>
                  }
                />
              )
            )}

            {showWithdrawPopup && (
              <SlideModal
                visible={showWithdrawPopup}
                type="center"
                customStyle={styles.withdrawModalPopup}>
                <PopUp
                  confirm={async () => {
                    await handleWithDraw();
                    setShowWithdrawPopup(false);
                    handleBack();
                    setIsJoining(false);
                  }}
                  cancel={() => setShowWithdrawPopup(false)}
                  text="Are you sure you want to withdraw from the tournament?"
                  buttonConfirm="Withdraw"
                />
              </SlideModal>
            )}
            {(showJoin || isPaidUnregistered) && (
              <Box>
                {false && (
                  <Box
                    style={{
                      position: 'absolute',
                      top: 0,
                      // left: 0,
                      right: 0,
                      width: 500,
                      backgroundColor: '#FFF4E5',
                      borderColor: '#FFA500',
                      borderWidth: 1,
                      padding: 10,
                      borderRadius: 8,
                      flexDirection: 'row',
                      alignItems: 'center',
                      zIndex: 100, // make sure it's on top
                    }}>
                    <MaterialCommunityIcons
                      name="alert-circle"
                      size={18}
                      color="#FFA500"
                      style={{marginRight: 8}}
                    />
                    <CCText style={{color: '#5B5B5B', flex: 1}}>
                      You have already joined another tournament. Withdraw from
                      it to join this one.
                    </CCText>
                    <TouchableOpacity onPress={() => setShowWarning(false)}>
                      <MaterialCommunityIcons
                        name="close"
                        size={18}
                        color="#5B5B5B"
                      />
                    </TouchableOpacity>
                  </Box>
                )}

                <CCButton
                  style={styles.ctaButton}
                  disabled={
                    tournamentData?.data?.player_fide_ids
                      ?.split(',')
                      .includes(userId) ||
                    statusMessage == 'All Rounds Completed Successfully'
                  }
                  onPress={
                    isPaidUnregistered
                      ? () => setShowPaidRegisterModal(true)
                      : handleJoin
                  }>
                  {!isPaidUnregistered && isJoining ? (
                    <DotLoader />
                  ) : (
                    <CCText style={styles.ctaText}>
                      {isPaidUnregistered ? 'Register' : 'Join'}
                    </CCText>
                  )}
                </CCButton>
              </Box>
            )}
          </View>
        </View>
      }

      {!isMobileOrTab && (
        <Box style={styles.playModeContainer}>
          <Box
            onPress={() => {
              setActiveTab('notation');
            }}
            style={[styles.playButtonStyle, styles.playButtonStyleLeft]}>
            {activeTab == 'notation' && (
              <Image
                source={require('@/Assets/Images/Caissa/TournamenTab.svg')}
                style={[
                  {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    borderTopLeftRadius: 8,
                    borderBottomLeftRadius: 8,
                  },
                ]}
              />
            )}
            <CCText
              style={[
                styles.playButtonTxtStyle,
                activeTab == 'notation' && {color: CCColors.White},
              ]}>
              Game
            </CCText>
          </Box>

          <Box
            onPress={() => {
              if (viewPlayer) {
                setActiveTab('standings');
              } else {
                setActiveTab('games');
              }

              if (!playing) {
                if (watchGame) {
                  setGameId('stop_watching');
                } else {
                  setGameId('');
                  setStarted(false);
                  setPosition(
                    'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
                  );
                }
              }
              setMyTimeTournament(timeControlRef.current);
              setOpponentTimeTournament(timeControlRef.current);
              getTournamentStatus(tournamentId);
            }}
            style={[styles.playButtonStyle, styles.playButtonStyleRight]}>
            {activeTab !== 'notation' && (
              <Image
                source={require('@/Assets/Images/Caissa/TournamenTab.svg')}
                style={[
                  {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    borderTopRightRadius: 8,
                    borderBottomRightRadius: 8,
                  },
                ]}

                // resizeMethod="scale"
                // resizeMode="stretch"
              />
            )}

            <CCText
              style={[
                styles.playButtonTxtStyle,
                activeTab !== 'notation' && {color: CCColors.White},
              ]}>
              Tournament
            </CCText>
          </Box>
        </Box>
      )}
      {/* <TournamentEndedModal
        isVisible={showModal}
        handleClose={handleClose}
        rank={rank}
        totalPlayers={totalPlayers}
        totalRoundsPlayed={roundsPlayed}
        BlitzRating={rating}
        handleViewStandings={() => {
          setActiveTab('standings');
          setShowModal(false);
        }}
        score={score}
      /> */}
      {tournamentData?.data?.parent_id &&
        !tournamentData?.data?.is_qualified && (
          <>
            <LinearGradient
              colors={[
                'rgba(235, 87, 87, 0)',
                'rgba(235, 87, 87, 0.2)',
                'rgba(235, 87, 87, 0)',
              ]}
              locations={[0, 0.5, 0.9712]}
              start={{x: 0, y: 0}}
              end={{x: 1, y: 0}}
              style={styles.TimerContainer}>
              <CCText
                fontSize={FontSizes[12]}
                color={'#EB5757'}
                style={{
                  fontWeight: '500',
                  alignSelf: 'center',
                  justifyContent: 'center',
                }}>
                {qualificationStatusMessage}{' '}
              </CCText>
            </LinearGradient>
            <Spacer spacing={8} />
          </>
        )}
      {activeTab !== 'notation' && (
        <LinearGradient
          colors={[
            'rgba(250, 246, 235, 0)',
            'rgba(250, 246, 235, 1)',
            '#F6E5B6',
            '#F6E5B6',
            'rgba(250, 246, 235, 1)',
            'rgba(250, 246, 235, 0)',
          ]}
          locations={[0, 0.2, 0.35, 0.65, 0.8, 1]}
          start={{x: 0, y: 0}}
          end={{x: 1, y: 0}}
          style={styles.TimerContainer}>
          <Box flexDirection="row">
            <CCText style={styles.statusText}>{statusMessage} </CCText>
            {timeLeft && <CCText style={styles.timeText}>{timeLeft}</CCText>}
          </Box>
        </LinearGradient>
      )}
      {/* Tabs */}
      {activeTab !== 'notation' && (
        <View style={styles.tabs}>
          <TouchableOpacity
            style={[styles.tab, activeTab === 'standings' && styles.activeTab]}
            onPress={() => setActiveTab('standings')}>
            <CCText style={styles.tabText}>
              {' '}
              <CCText style={styles.tabText}>
                {tournamentStarted ? 'Standings' : 'Players'}
              </CCText>
            </CCText>
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.tab, activeTab === 'games' && styles.activeTab]}
            onPress={() => setActiveTab('games')}>
            <CCText style={styles.tabText}>Pairings</CCText>
          </TouchableOpacity>

          {/* <TouchableOpacity
            style={[styles.tab, activeTab === 'chat' && styles.activeTab]}
            onPress={() => setActiveTab('chat')}
          >
            <CCText style={styles.tabText}>Chat</CCText>
        </TouchableOpacity> */}

          <TouchableOpacity
            style={[styles.tab, activeTab === 'details' && styles.activeTab]}
            onPress={() => setActiveTab('details')}>
            <CCText style={styles.tabText}>Details</CCText>
          </TouchableOpacity>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 5,
              marginRight: 10,
            }}>
            <TouchableOpacity
              onPress={() => {
                rotateIcon();
                setRefreshApi(true);
                setPlayerUserId(null);
                getTournamentStatus(tournamentId);
              }}>
              <Box
                style={{
                  width: 35,
                  height: 35,
                  backgroundColor: CCColors.Primary.lightBrown,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 20,
                }}>
                <Animated.View style={{transform: [{rotate: spin}]}}>
                  <MaterialCommunityIcons
                    name="reload"
                    color={CCColors.Primary.Brown}
                    size={22}
                  />
                </Animated.View>
              </Box>
            </TouchableOpacity>
            {activeTab !== 'details' && (
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 5,
                  marginRight: 10,
                }}>
                {tournamentData?.data?.is_joined && activeTab === 'games' && (
                  <TouchableOpacity
                    onPress={() => {
                      setPlayerUserId(userId);
                    }}>
                    <Box
                      style={{
                        width: 35,
                        height: 35,
                        backgroundColor: playerUserId
                          ? CCColors?.HighlightColor
                          : CCColors.Primary.lightBrown,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 20,
                      }}>
                      <MaterialCommunityIcons
                        name="crosshairs-gps"
                        color={CCColors.Primary.Brown}
                        size={22}
                      />
                    </Box>
                  </TouchableOpacity>
                )}
                {showSearch && (
                  <TouchableOpacity
                    // style={{marginLeft: '23%', marginRight: '2%'}}
                    onPress={() => {
                      if (searchTab) {
                        setSearchTerm('');
                      }
                      setSearchTab(!searchTab);
                    }}>
                    <Box
                      style={{
                        width: 35,
                        height: 35,
                        backgroundColor: CCColors.Primary.lightBrown,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 20,
                      }}>
                      <MaterialCommunityIcons
                        name={searchTab ? 'close' : 'magnify'}
                        color={CCColors.Primary.Brown}
                        size={22}
                      />
                    </Box>
                  </TouchableOpacity>
                )}
              </View>
            )}
          </View>
        </View>
      )}
      {searchTab && activeTab !== 'details' && (
        <Box style={{margin: 10}}>
          <CCTextInput
            icon={search}
            fontSize={FontSizes[18]}
            value={searchTerm}
            style={{
              height: 45,
              backgroundColor: CCColors.White,
              overflow: 'hidden',
              borderRadius: 8,
            }}
            placeholder={'Search a Player'}
            onChangeText={text => {
              setSearchTerm(text);
            }}
            inputType="text"
            placeholderTextColor={CCColors.TextColor.Grey}
          />
        </Box>
      )}

      {/* Render Active Tab */}
      <View style={styles.tabContent}>{renderActiveTab()}</View>
      <PaidTournamentRegistrationModal
        visible={showPaidRegisterModal || Boolean(routeOrderId)}
        tournament={tournamentData?.data || null}
        userId={String(userId || '')}
        onClose={() => {
          setShowPaidRegisterModal(false);
          if (routeOrderId) {
            // @ts-ignore
            navigation.setParams({order_id: undefined});
          }
        }}
        onRefreshDetails={() => fetchTournamentDetails({tournamentId, userId})}
        orderId={routeOrderId}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    paddingHorizontal: 16,
    borderRadius: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 16,
    paddingHorizontal: 8,
  },
  titleContainer: {
    flex: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  tab: {
    flex: 1,
    paddingVertical: 10,
    alignItems: 'center',
  },
  activeTab: {
    borderBottomWidth: 3,
    borderBottomColor: '#FFC107',
  },
  tabText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333',
  },
  backButton: {
    padding: 8,
    marginRight: 16,
  },
  subtitle: {
    fontSize: 14,
    color: '#666',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconButton: {
    backgroundColor: updateColorWithOpacity(
      CCColors?.WrongMoves?.Background,
      0.16,
    ),
    borderRadius: 32,
    overflow: 'hidden',
    width: '100%',
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginHorizontal: 5,
  },
  ctaButton: {
    marginLeft: 10,
  },
  ctaText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: CCColors?.TextColor?.Dark,
  },
  tabs: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  tabButton: {
    flex: 1,
    paddingVertical: 12,
    alignItems: 'center',
  },
  activeTabText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
  },
  tabContent: {
    flex: 1,
    marginTop: 16,
    height: 'auto',
  },
  TimerContainer: {
    flexDirection: 'row',
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  statusText: {
    fontSize: FontSizes[12],
    fontWeight: '500',
    color: CCColors?.TextColor?.Primary,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  timeText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#666',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  playModeContainer: {
    flexDirection: 'row',
    overflow: 'visible',
    margin: 16,
    // marginTop: 40,
    alignItems: 'center',
    justifyContent: 'space-between',
    // flex: 1,
  },
  playModeContainerSelected: {
    backgroundColor: CCColors?.Primary?.Brown,
  },
  playButtonTxtStyle: {
    paddingVertical: 14,
  },
  playButtonStyle: {
    position: 'relative',
    flex: 0.5,

    // overflowY: 'hidden',
    // aspectRatio: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: CCColors.White,
  },
  playButtonStyleLeft: {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#2623221A',
    // border: 1px solid #2623221A
  },
  playButtonStyleRight: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#2623221A',
  },
  withdrawModalPopup: {
    borderRadius: 12,
    backgroundColor: 'white',
    zIndex: 5,
    overflowY: 'hidden',
    minWidth: '20%',
    margin: 'auto',
  },
});

export default TournamentPlay;
